import React, { Component, ErrorInfo } from 'react';
import { toString } from 'ramda';
import { InternalError } from '../InternalError/InternalError';
import Logger from '../../Utils/Logger';

interface IProps {
  children: React.ReactNode;
  name: string;
  info?: object;
}

interface IState {
  hasError: boolean;
  error: any;
  errorInfo: any;
}

/**
  Kan användas för att wrappa andra komponenter,
  om det uppstår ett internt javascript error i den
  wrappade komponenten så visar denna komponent ett felmeddealande.

  läs mer: https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html
*/
class ErrorBoundary extends Component<IProps, IState> {
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  constructor(props: IProps) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Logger.log(
      'error',
      `Ohanterat fel i ${this.props.name}: ${error.message}`,
      error.message,
      error,
      info,
      {
        reporter: 'ErrorBoundary -' + this.props.name,
        fingerprint: `ErrorBoundary-${this.props.name}-${error.name}`,
      }
    );
  }

  render() {
    if (this.state.hasError) {
      // visa felmeddelande
      return (
        <InternalError
          id={`ErrorBoundary ${this.props.name}`}
          message={`${
            this.props.name
          } har slutat fungera med följande felmeddelande:
${toString(this.state.error)}`}
          skipErrorLogging
        />
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
